import PublicLayout from "../../modules/ui/components/PublicLayout";
import BgGlassmorphism from "../../modules/ui/components/BgGlassmorphism/BgGlassmorphism";
import BookingList from "./BookingList";
import React from "react";

const PageBookings = () => {
    return (
        <PublicLayout>
            <div className="nc-PageHome relative overflow-hidden mt-4">
                <BgGlassmorphism />
                <div className="container relative space-y-5 mb-24 lg:space-y-5">
                    <BookingList/>
                </div>
            </div>
        </PublicLayout>
    );
}

export default PageBookings;
